import { DROPDOWN_SELECT_STUDY_LEAVE_REQUEST } from "../../../enums/Request/request.types";

export const dropdownSelectionStudyLeave = ({ event, el, stateName }) => {
    return {
        type: DROPDOWN_SELECT_STUDY_LEAVE_REQUEST,
        payload: { el, stateName },
    };
};
